import script from "./EventSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSettings.vue?vue&type=script&setup=true&lang=js"

import "./EventSettings.vue?vue&type=style&index=0&id=b9cb21ac&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9cb21ac"]])

export default __exports__